import React from "react";
import { CardTheme } from "../types";

interface Wild4SymbolProps {
  theme: CardTheme;
}

export const Wild4Symbol: React.FC<Wild4SymbolProps> = React.memo(({ theme }) => {
  const { width, height } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const size = Math.min(width, height) * 0.3;
  const fontSize = width * 0.15;
  const cornerFontSize = width * 0.12;

  // Four colored quadrants with "+4" text
  return (
    <g>
      {/* Red quadrant (top-left) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX} ${centerY - size} L ${centerX - size} ${centerY} Z`}
        fill={theme.colors.red}
      />
      {/* Blue quadrant (top-right) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX + size} ${centerY} L ${centerX} ${centerY - size} Z`}
        fill={theme.colors.blue}
      />
      {/* Green quadrant (bottom-left) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX - size} ${centerY} L ${centerX} ${centerY + size} Z`}
        fill={theme.colors.green}
      />
      {/* Yellow quadrant (bottom-right) */}
      <path
        d={`M ${centerX} ${centerY} L ${centerX} ${centerY + size} L ${centerX + size} ${centerY} Z`}
        fill={theme.colors.yellow}
      />
      {/* Center "+4" text */}
      <text
        x={centerX}
        y={centerY}
        fontSize={fontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        +4
      </text>
      
      {/* Top-left corner +4 */}
      <text
        x={width * 0.15}
        y={height * 0.2}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        +4
      </text>

      {/* Bottom-right corner +4 (rotated) */}
      <text
        x={width * 0.85}
        y={height * 0.8}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        transform={`rotate(180 ${width * 0.85} ${height * 0.8})`}
      >
        +4
      </text>
    </g>
  );
});

Wild4Symbol.displayName = "Wild4Symbol";
